import React from 'react';
import reactDom from '../../../common/react/dom/index';
import ProductDetail from '../../../components/frontend/productdetail/ProductDetail';

export default function init() {
	reactDom(<ProductDetail />, 'js-react-productdetail');
}
